/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

function ATMFieldServicesReport({ data }: { data: any[] }) {
  const [dataState, setDataState] = useState<any>(initialDataState);

  return (
    <Grid
      data={process(
        data.map((req) => ({
          ...req,
        })),
        dataState
      )}
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
    >
      <Column
        field="serialNo"
        title="Sr. #"
        width="70px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="customer"
        title="Customer"
        width="120px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationId"
        title="Location Id"
        width="120px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationName"
        title="Location Name"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="maker"
        title="Maker"
        width="80px"
        className="grid-cell-font-size"
      />
      <Column
        field="serviceType"
        title="Service Type"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="routeNo"
        title="Route No"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="ccDepartTime"
        title="CC Depart"
        width="120px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="serviceStartTime"
        title="Start Time"
        width="130px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="serviceEndTime"
        title="End Time"
        width="120px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="ccArrivalTime"
        title="CC Arrival"
        width="120px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="handoverTime"
        title="Handover"
        width="120px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="status"
        title="Status"
        width="100px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="reason"
        title="Pending Reason"
        width="180px"
        className="grid-cell-font-size text-center"
      />
      <Column field="remarks" title="remarks" className="grid-cell-font-size" />
    </Grid>
  );
}

export default React.memo(ATMFieldServicesReport);
